import { supabase } from "@/integrations/supabase/client";

const normalizeText = (text: string): string => {
  if (!text) return text;
  // Trim whitespace
  return text.trim();
};

export const titleCase = (str: string): string => {
  if (!str) return str;

  const wordsToKeepLowercase = ['de', 'la', 'y', 'en', 'del', 'el', 'las', 'los', 'con', 'por', 'para', 'a', 'e', 'o', 'u'];

  return str.split(' ').map((word, index) => {
    // La primera palabra siempre va en mayúscula inicial
    if (index === 0) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }

    // Palabras pequeñas van en minúscula
    if (wordsToKeepLowercase.includes(word.toLowerCase())) {
      return word.toLowerCase();
    }

    // El resto va en mayúscula inicial
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }).join(' ');
};

export const getAttributesFromSettings = async () => {
    // Read via public edge function so unauthenticated signup/landing pages work
    // after removing anon RLS on platform_settings.
    const { data, error } = await supabase.functions.invoke('platform-settings', { method: 'GET' });

    const empty = { universities: [] as string[], states: [] as string[], institutions: [] as string[], specialties: [] as string[], blog_categories: [] as string[], blog_tags: [] as string[] };

    if (error) {
        console.error("Error fetching attributes settings:", error);
        return empty;
    }

    const obj = (data ?? {}) as Record<string, any>;
    const normalizeList = (list: any) =>
        Array.isArray(list) ? list.map(item => typeof item === 'string' ? normalizeText(item) : item) : [];
    const normalizeAndTitleCaseList = (list: any) =>
        Array.isArray(list) ? list.map(item => typeof item === 'string' ? titleCase(normalizeText(item)) : item) : [];

    return {
        universities: normalizeList(obj.universities),
        states: normalizeList(obj.states),
        institutions: normalizeList(obj.institutions),
        specialties: normalizeAndTitleCaseList(obj.specialties),
        blog_categories: normalizeList(obj.blog_categories),
        blog_tags: normalizeList(obj.blog_tags),
    };
};

export const saveAttributesToSettings = async (key: 'universities' | 'states' | 'institutions' | 'specialties' | 'blog_categories' | 'blog_tags', values: string[]) => {
    // También normalizamos al guardar para mantener la base de datos limpia
    const normalizedValues = values.map(v => typeof v === 'string' ? (key === 'specialties' ? titleCase(normalizeText(v)) : normalizeText(v)) : v);
    
    const { error } = await supabase.from('platform_settings').upsert({
        key,
        value: normalizedValues
    });

    if (error) throw error;
}
